import React from "react"
import { GridRow, GridColumn, ToggleSwitch, DateTimeInput, CheckboxProps } from "@metsooutotec/modes-react-components"

interface SensorDateInputFieldProps {
    isManufactured: boolean
    manufacturedDate: string
    handleIsManufacturedToggle: (e: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => void
    handleDateChange: (value: string) => void
    datePickerError: { isError: boolean; errorMessage: string }
    labelManufactured: string
    labelManufacturedDate: string
}

const SensorDateInputField: React.FC<SensorDateInputFieldProps> = ({
    isManufactured,
    manufacturedDate,
    handleIsManufacturedToggle,
    handleDateChange,
    datePickerError,
    labelManufactured,
    labelManufacturedDate,
}) => {
    return (
        <GridRow style={{ alignItems: "center" }}>
            <GridColumn>
                <ToggleSwitch noStatusText label={labelManufactured} checked={isManufactured} onChange={handleIsManufacturedToggle} />
            </GridColumn>
            {isManufactured && (
                <GridColumn>
                    <DateTimeInput
                        label={labelManufacturedDate}
                        onChange={(value: string | any) => handleDateChange(value.toString())}
                        value={manufacturedDate}
                        format='DD-MMM-YYYY'
                        timeFormat={false}
                        error={datePickerError.errorMessage}
                    />
                </GridColumn>
            )}
        </GridRow>
    )
}

export default SensorDateInputField
